import React, { useCallback, useEffect, useState } from "react";
import Input from "../../../components/controls/input/customInput/CustomInput";
import InputUnderline from "../../../components/controls/input/InputUnderline";
import { CalendarIcon, AddIconSvg } from "../../../modules/default-svg";
import service from "../../../store/services/user.service";
import portfolioService from "../../../store/services/portfolio.service";
import Button from "../../../components/controls/button/Button";
import Searchable from "../../../components/controls/select/CustomSelect";
import { ColumnConfigProvider } from "../../../components/controls/tables/ColumnConfigProvider";
import DeleteRequest from "../../../components/DeleteRequest/DeleteRequest";
import { useDispatch } from "react-redux";
import { generalActions } from "../../../store/actions";
import { calculatePageSize, UserSearchRefType } from "../../../helpers/utils";
import Table from "../../../components/controls/tables/Table";
import RichTextEditor from "../../../components/richTextEditor/RichTextEditor";
import EntityFileUpload from "../../../components/controls/fileUpload/EntityFileUpload";
import { isDateGreaterThan } from "../../../utils/systemSettings";
import UserSelect from "../../../components/userSelect/UserSelect";

const Portfolios = (props) => {
  const {
    clientID,
    defaultClient,
    allPortFolios,
    pageLoading,
    loading,
    pagination,
    getPortFolioRequest,
    createPortFolioRequest,
    updatePortFolioRequest,
    error,
    overviewType,
    dashboardFilterSetId,
    dashboardFilterSetName,
  } = props;
  const permissions = localStorage.getItem("permissions");
  const [isModalLoading, setIsModalLoading] = useState(false);
  useEffect(() => {
    setIsModalLoading(loading);
  }, [loading]);
  const [data, setData] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [perPageItems] = useState(calculatePageSize());
  const [name, setName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [budget, setBudget] = useState("");
  const [status, setStatus] = useState("");
  const [refId, setRefId] = useState("");
  const [riskLevel, setRiskLevel] = useState("");
  const [portfolioId, setPortFolioId] = useState("");
  const [clients, setClients] = useState([]);
  const [stakeholder, setStakeholder] = useState("");
  const [objectives, setObjectives] = useState("");
  const [description, setDescription] = useState("");
  const [selectedRow, setSelectedRow] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [client, setClient] = useState({});
  const [manager, setManager] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [isCreate, setIsCreate] = useState(false);
  const [isCreateNewRow, setIsCreateNewRow] = useState(false);
  const [isHeader, setIsHeader] = useState(true);
  const [parentType, setParentType] = useState(null);
  const [formErrors, setFormErrors] = useState({
    name: "",
    startDate: "",
    endDate: "",
    client,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [deleteRequestModal, setDeleteRequestModal] = useState(false);
  const [deleteRequestData, setDeleteRequestData] = useState({});
  const [deleteModal, setDeleteModal] = useState(null);
  const [deleteId, setDeletedId] = useState(null);
  const dispatch = useDispatch();
  const [tableSearch, setTableSearch] = useState(null);

  const fetchData = (pageNumber, pageSize, searchTerm, forceClearSearch = false) => {
    const payload = { page: pageNumber ?? pageNum, size: pageSize ?? perPageItems, search: forceClearSearch ? null : (searchTerm ?? tableSearch) };
    payload.parent = parentType;

    if (clientID) {
      payload.id = clientID;
      payload.parent = "Client";
    }
    getPortFolioRequest(payload);
  };

  const handleAddRow = useCallback(() => {
    setIsCreateNewRow(true);
    fetchData(pagination.TotalPages ?? 1, perPageItems > 10 ? perPageItems - 5 : perPageItems - 3);
  }, []);

  useEffect(() => {
    if (error !== "" && error) {
      Object.keys(error).forEach((key) => {
        if (key === "Name") {
          setFormErrors((prevErrors) => ({
            ...prevErrors,
            name: error[key][0],
          }));
        }
        if (key === "ClientId") {
          setFormErrors((prevErrors) => ({
            ...prevErrors,
            client: "Client field is required.",
          }));
        }
      });
    } else {
      setFormErrors({});
    }
  }, [error]);

  const searchClientHandler = (value) => {
    if (value === "") {
      setClients([]);
      return;
    }
    // if (value) {
    service
      .searchClientDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj?.name,
          value: obj?.id,
        }));
        setClients(transformedArray);
      })
      .catch(() => {
        setClients([]);
      });
    // }
  };

  const fetchPortfolioData = async () => {
    setIsLoading(true);
    portfolioService
      .getPortfolioDetails({ id: selectedRow.id })
      .then((portfolioData) => {
        setName(portfolioData.name);
        setBudget(portfolioData.budget);
        setStatus(portfolioData.status);
        setPortFolioId(portfolioData.id);
        setRiskLevel(portfolioData.riskLevel);
        setStartDate(portfolioData.startDate);
        setEndDate(portfolioData.endDate);
        setObjectives(portfolioData.objectives);
        setDescription(portfolioData.description);
        setStakeholder(portfolioData.stakeholders);
        setAttachments(portfolioData.attachments || []);
        setRefId(portfolioData.refId);
        setClient({
          value: portfolioData?.client?.id,
          label: portfolioData?.client?.name,
        });
        setManager(portfolioData?.owner);
        setIsLoading(false);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };

  useEffect(() => {
    if (defaultClient) {
      setClient({ value: defaultClient.id, label: defaultClient.name });
    }
  }, [defaultClient]);

  useEffect(() => {
    if (Object.keys(selectedRow).length > 0) {
      isEdit && fetchPortfolioData();
    } else {
      setName("");
      setBudget("");
      setStatus("");
      setPortFolioId("");
      setRiskLevel("");
      setStartDate("");
      setEndDate("");
      setDescription("");
      setObjectives("");
      setStakeholder("");
      setRefId("");
      defaultClient
        ? setClient({ value: defaultClient.id, label: defaultClient.name })
        : setClient("");
    }
  }, [selectedRow, isEdit]);

  const handleCancelAddRow = () => {
    setIsCreateNewRow(false);
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [pageNum, perPageItems]);

  const formBody = () => {
    return (
      <>
        <InputUnderline
          placeholder="Add portfolio name"
          value={name}
          handleChange={(value) => handleInputChange(value, "name")}
          error={formErrors.name}
          isRequired
          loading={isLoading}
        />
        <div className="d-flex mb-3">
          {parentType !== "Client" && (
            <>
              <div className="mt-4 w-50">
                <Searchable
                  label="Client"
                  selectWd="me-3"
                  SelectText="client"
                  searchText={searchClientHandler}
                  options={clients}
                  defaultVal={client}
                  onChange={(value) => handleInputChange(value, "client")}
                  errorMessage={formErrors.client}
                  isRequired
                  loading={isLoading}
                />
              </div>
            </>
          )}
        </div>
        <div className="row align-items-start gx-3 mb-3">
          <div className="col-4">
            <UserSelect
              refType={UserSearchRefType.Client}
              refId={client?.value}
              label="Portfolio Manager"
              buttonLabel={"Select Manager"}
              value={manager}
              onChange={setManager}
              loading={isLoading}
              disabled={!client}
            />
          </div>
        </div>
        <div className="row align-items-start gx-3 mb-3">
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={startDate}
              maxDate={endDate}
              type="date"
              handleChange={(value) => handleInputChange(value, "startDate")}
              label="Start Date"
              errorMessage={formErrors.startDate}
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={endDate}
              minDate={startDate}
              type="date"
              handleChange={(value) => handleInputChange(value, "endDate")}
              label="End Date"
              errorMessage={formErrors.endDate}
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              // placeholder="Enter budget"
              value={budget}
              type="number"
              // type="number"
              currency={true}
              placeholder="0"
              handleChange={setBudget}
              label="Budget"
              loading={isLoading}
            />
          </div>
        </div>

        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <Input
              icon={false}
              value={refId}
              type="text"
              placeholder="Enter reference ID"
              handleChange={setRefId}
              label="Reference ID"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter status"
              value={status}
              type="text"
              handleChange={setStatus}
              label="Status"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter risk level"
              value={riskLevel}
              type="text"
              handleChange={setRiskLevel}
              label="Risk level"
              errorMessage={formErrors.riskLevel}
              loading={isLoading}
            />
          </div>
        </div>

        <RichTextEditor
          label="Description"
          content={description}
          onChange={setDescription}
          loading={isLoading}
        />
        <div className="mb-3">
          <RichTextEditor
            label="Stakeholders"
            content={stakeholder}
            onChange={setStakeholder}
            loading={isLoading}
          />
        </div>
        <div className="mb-3">
          <RichTextEditor
            label="Objectives"
            content={objectives}
            onChange={setObjectives}
            loading={isLoading}
          />
        </div>

        <EntityFileUpload
          entityId={selectedRow.id}
          entityType="Portfolio"
          attachments={attachments}
          onAttachmentsChange={() => {
            // Refresh portfolio data to get updated attachments
            if (selectedRow.id) {
              portfolioService.getPortfolioDetails({ id: selectedRow.id })
                .then((portfolioData) => {
                  setAttachments(portfolioData.attachments);
                })
                .catch((error) => {
                  console.error("Error fetching portfolio data:", error);
                });
            }
          }}
          disabled={isLoading || !selectedRow.id}
        />
      </>
    );
  };

  const handleInputChange = (value, name) => {
    if (name === "startDate") setStartDate(value);
    if (name === "endDate") setEndDate(value);

    if (name === "name") {
      setName(value);
      if (formErrors && value) {
        setFormErrors({
          ...formErrors,
          [name]: "",
        });
      }
    }
    if (name === "client") {
      setClient(value);
      setManager(null);
      if (formErrors && value) {
        setFormErrors({
          ...formErrors,
          [name]: "",
        });
      }
    }
  };

  const handleDelete = (selectedRow) => {
    // if(!isDisable){
    // const id = JSON.parse(localStorage.getItem("selectedRow")).id;
    const id = selectedRow.id;
    setIsModalLoading(true);
    portfolioService
      .deletePortfolioRequest({ id })
      .then((response) => {
        if (response && !response.IsDeletionAllowed) {
          setDeleteRequestData(response);
          setDeleteRequestModal(true);
        } else {
          // localStorage.removeItem("selectedRow");
          dispatch(
            generalActions.showToast({
              title: "Portfolio deleted successfully.",
              type: "success",
            })
          );
          setDeletedId(id);
          fetchData();
        }
      })
      .catch((err) => {
        dispatch(
          generalActions.showToast({
            title: "Something went wrong. Please try again later.",
            type: "error",
          })
        );
      })
      .finally(() => {
        setSelectedRow({});
        setDeleteModal(false);
        setIsModalLoading(false);
      });
  };

  const handleDeleteRequested = () => {
    fetchData();
  };
  const handleCreate = () => {
    setIsCreate(true);
    setManager(null);
  };

  const handleSave = () => {
    if (!isDisable) {
      const errors = {};
      if (!name) errors["name"] = `The Name field is required.`;
      if (!clientID && !client) errors["client"] = `Client field is required.`;

      if (startDate && endDate && isDateGreaterThan(startDate, endDate)) {
        errors[
          "endDate"
        ] = `End date must be equal to or greater than start date.`;
      }
      setFormErrors(errors);
      if (Object.keys(errors).length) {
        return;
      }
      const payload = {
        Name: name,
        StartDate: startDate || null,
        EndDate: endDate || null,
        Budget: budget ? budget : 0,
        RiskLevel: riskLevel,
        Status: status,
        RefId: refId,
        Description: description,
        // ClientId: clientID ? clientID : client && client.value,
        ClientId: client?.value,
        Stakeholders: stakeholder,
        objectives: objectives,
        OwnerId: manager && manager.id,
        //"assignedUsers": resources,
      };

      let data = {};
      if (Object.keys(selectedRow).length > 0) {
        data = { id: portfolioId, payload };
        if (clientID) {
          data.clientId = clientID;
        }
        updatePortFolioRequest(data);
      } else {
        data = { payload };
        if (clientID) {
          data.clientId = clientID;
        }
        createPortFolioRequest(data);
      }
    }
  };

  const handleCancel = () => {
    setFormErrors({});
    setIsEdit(false);
    setManager(null);
  };

  const handleSearch = (filteredData) => {
    setData(filteredData);
    setIsEdit(false);
  };

  useEffect(() => {
    if (clientID) {
      setParentType("Client");
      setIsHeader(false);
    }
    setData([]);
    setPageNum(1);
    setDeletedId(null);
  }, [clientID]);

  useEffect(() => {
    if (allPortFolios && allPortFolios.length > 0) {
      if (isCreateNewRow) {
        setData(
          allPortFolios.sort((a, b) => {
            return b.isFlagged - a.isFlagged;
          })
        );
        setIsCreateNewRow(false);
      } else {
        if (pageNum === 1) {
          setData(
            allPortFolios
              .filter((item) => item.id !== deleteId)
              .sort((a, b) => {
                return b.isFlagged - a.isFlagged;
              })
          );
        } else {
          setData((prevData) => {
            const newMap = new Map(
              allPortFolios.map((item) => [item.id, item])
            );

            const updatedPrevData = prevData.map((item) =>
              newMap.has(item.id) ? newMap.get(item.id) : item
            );

            const prevDataIds = new Set(prevData.map((item) => item.id));
            const newItems = allPortFolios.filter(
              (shift) => !prevDataIds.has(shift.id)
            );

            return [...updatedPrevData, ...newItems]
              .filter((item) => item.id !== deleteId)
              .sort((a, b) => b.isFlagged - a.isFlagged);
          });
        }
      }
    } else if (allPortFolios && allPortFolios.length === 0 && pageNum === 1) {
      setData([]);
    }

    setIsCreate(false);
    setIsEdit(false);
    setSelectedRow({});
    setManager(null);
  }, [allPortFolios, deleteId, pageNum, isCreateNewRow]);

  useEffect(() => {
    if (clientID) {
      // Reset form states when switching clients
      setSelectedRow({});
      setIsEdit(false);
      setIsCreate(false);
      setFormErrors({});
      setName("");
      setBudget("");
      setStatus("");
      setPortFolioId("");
      setRiskLevel("");
      setStartDate("");
      setEndDate("");
      setDescription("");
      setObjectives("");
      setStakeholder("");
      setRefId("");
      setClients([]);
      setManager(null);

      // Reset client to default
      if (defaultClient) {
        setClient({ value: defaultClient.id, label: defaultClient.name });
      } else {
        setClient({});
      }
    }
  }, [clientID, defaultClient]);
  useEffect(() => {
    if (name) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        name: "",
      }));
    }
  }, [name]);

  const [isDisable, setIsDisable] = useState(false);

  useEffect(() => {
    if (loading) setIsDisable(true);
    else setIsDisable(false);
  }, [loading]);

  const handleSearchTrigger = (searchTerm) => {
    if ((!tableSearch && !searchTerm) || (tableSearch === searchTerm)) return;

    let pageNumber = pageNum;
    if (!tableSearch || (tableSearch && !searchTerm) || (tableSearch !== searchTerm)) {
      setData([]); //clear existing data
      pageNumber = 1; //reset to first page
    }

    setTableSearch(searchTerm);
    fetchData(pageNumber, perPageItems, searchTerm, !searchTerm);
  }

  return (
    <ColumnConfigProvider
      tableName={parentType ? `${parentType}-Portfolio` : "Portfolio"}
    >
      <div className="listingScreen position-relative">
        {isHeader && overviewType !== "Dashboard" && (
          <div className="db_Subheader d-flex justify-content-between align-items-center mb-4">
            <h4>Portfolios</h4>
            {permissions?.includes("Portfolio.Create") && (
              <Button
                btnClass="d_btn d_btn_primary"
                icon={<AddIconSvg />}
                label="Add Portfolio"
                clickHandler={handleCreate}
              />
            )}
          </div>
        )}

        <Table
          type="Portfolio"
          isHeader={isHeader}
          parentType={parentType}
          overviewType={overviewType}
          rows={data || []}
          searchHandler={handleSearch}
          body={formBody()}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          setPageNum={setPageNum}
          perPageItems={perPageItems}
          setIsCreate={setIsCreate}
          handleSave={() => handleSave()}
          handleDelete={(selectedRow) => handleDelete(selectedRow)}
          handleCancel={() => handleCancel()}
          setIsEdit={setIsEdit}
          loading={pageLoading}
          modalLoading={isModalLoading}
          isCreate={isCreate}
          forceShowDeleteModal={deleteModal}
          pagination={pagination}
          setSelectedRow={setSelectedRow}
          clientId={clientID}
          dashboardFilterSetId={dashboardFilterSetId}
          dashboardFilterSetName={dashboardFilterSetName}
          handleAddRow={handleAddRow}
          handleCancelAddRow={handleCancelAddRow}
          setData={setData}
          triggerSearch={handleSearchTrigger}
        />
      </div>
      {deleteRequestModal && (
        <DeleteRequest
          data={deleteRequestData}
          handleCancel={setDeleteRequestModal}
          handleRefresh={() => handleDeleteRequested()}
        />
      )}
    </ColumnConfigProvider>
  );
};
export default Portfolios;
